import { useEffect, useState } from "react";
import "./PayPortal.css";



const logo = "/logo.png";
const API_URL = "https://7s92hnge48.execute-api.eu-central-1.amazonaws.com/prod/payment/start";
const API_BASE =
  "https://7s92hnge48.execute-api.eu-central-1.amazonaws.com/prod";



  const initialForm = {
  caseReference: "",
  debtorName: "",
  creditorName: "",
  amount: "",
  mobile: "",
  email: "",
  differentPayer: false,
  payerName: "",
  payerMobile: "",
  payerEmail: "",
};

function PayFooter() {
  return (
    <footer className="pay-footer">
      <div className="pay-footer-inner">
        <p>© 2026 DI Direkt Inkasso GmbH</p>

        <nav className="pay-footer-links">
          <a
            href="https://www.di-inkasso.de/impressum"
            target="_blank"
            rel="noreferrer"
          >
            Impressum
          </a>
          <a href="https://pay.debitormanager.com/datenschutz">Datenschutz</a>
<a href="https://pay.debitormanager.com/security">Sicherheit</a>
          <a href="mailto:info@direkt-inkasso.de">Kontakt</a>
        </nav>
      </div>
    </footer>
  );
}

 

export default function PayPortal() {
  const [form, setForm] = useState(initialForm);
  const [reviewMode, setReviewMode] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [paymentMode, setPaymentMode] = useState(false);
const [selectedMethod, setSelectedMethod] = useState("");
const [successMode, setSuccessMode] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);
const [submitError, setSubmitError] = useState("");
const [interactionId, setInteractionId] = useState("");

const params = new URLSearchParams(window.location.search);
const paymentStatus = params.get("payment");
const returnedInteractionId = params.get("interaction_id");

const paypalToken = params.get("token");

useEffect(() => {
  if (!paypalToken || (paymentStatus && paymentStatus !== "paypal_success")) return;

  async function capturePayPalPayment() {
    try {
      setIsSubmitting(true);

      const response = await fetch(`${API_BASE}/paypal/capture-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          order_id: paypalToken,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error("paypal/capture-order failed");
      }

      window.location.href = `/?payment=success&interaction_id=${encodeURIComponent(
        data.interaction_id || ""
      )}`;
    } catch (error) {
      console.error("PayPal Capture Fehler:", error);
      window.location.href = "/?payment=failed";
    }
  }

  capturePayPalPayment();
}, [paypalToken, paymentStatus]);

if (paymentStatus === "success" && !paypalToken) {
  return (
    <main className="pay-page">
      <header className="pay-header">
        <img src={logo} alt="DI - Direkt Inkasso GmbH" className="pay-logo" />
      </header>

      <section className="pay-review">
        <div className="pay-pills">
          <span>Zahlung erfolgreich</span>
        </div>

        <h1>Vielen Dank.</h1>
        <p className="pay-text">
          Ihre Zahlung wurde erfolgreich verarbeitet.
        </p>

        <div className="pay-review-card">
          <ReviewRow label="Vorgangsnummer" value={returnedInteractionId || "-"} />
          <ReviewRow label="Status" value="Zahlung erfolgreich" />
        </div>
      </section>
      <PayFooter />
    </main>
  );
}

if (paymentStatus === "cancelled") {
  return (
    <main className="pay-page">
      <header className="pay-header">
        <img src={logo} alt="DI - Direkt Inkasso GmbH" className="pay-logo" />
      </header>

      <section className="pay-review">
        <div className="pay-pills">
          <span>Zahlung abgebrochen</span>
        </div>

        <h1>Die Zahlung wurde nicht abgeschlossen.</h1>

        <p className="pay-text">
          Es wurde keine Zahlung durchgeführt. Sie können den Zahlungsvorgang
          jederzeit erneut starten.
        </p>

        <div className="pay-review-actions">
          <button
            className="pay-button"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Erneut versuchen
          </button>
        </div>
      </section>
    </main>
  );
}

if (paymentStatus === "failed") {
  return (
    <main className="pay-page">
      <header className="pay-header">
        <img src={logo} alt="DI - Direkt Inkasso GmbH" className="pay-logo" />
      </header>

      <section className="pay-review">
        <div className="pay-pills">
          <span>Zahlung nicht abgeschlossen</span>
        </div>

        <h1>Die Zahlung konnte nicht bestätigt werden.</h1>
        <p className="pay-text">
          Bitte versuchen Sie es erneut oder kontaktieren Sie uns.
        </p>

        <button
          type="button"
          className="pay-button"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          Erneut versuchen
        </button>
      </section>
      <PayFooter />
    </main>
  );
}


  const updateField = (name, value) => {
    setForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

const startStripeCheckout = async () => {
  setIsSubmitting(true);
  setSubmitError("");

  try {
    const startResponse = await fetch(`${API_BASE}/payment/start`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        caseReference: form.caseReference,
        debtorName: form.debtorName,
        creditorName: form.creditorName,
        amount: form.amount,
        mobile: form.mobile,
        email: form.email,
        differentPayer: form.differentPayer,
        payerName: form.payerName,
        payerMobile: form.payerMobile,
        payerEmail: form.payerEmail,
        selectedMethod,
      }),
    });

    const startData = await startResponse.json();

    if (!startResponse.ok || !startData.success) {
      throw new Error("payment/start failed");
    }


    setInteractionId(startData.interaction_id);

if (selectedMethod === "paypal") {
  const paypalResponse = await fetch(`${API_BASE}/paypal/create-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      interaction_id: startData.interaction_id,
      amount: form.amount,
    }),
  });

  const paypalData = await paypalResponse.json();

  if (!paypalResponse.ok || !paypalData.success || !paypalData.approval_url) {
    throw new Error("paypal/create-order failed");
  }

  window.location.href = paypalData.approval_url;
  return;
}


    const sessionResponse = await fetch(`${API_BASE}/payment/create-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        interaction_id: startData.interaction_id,
        amount: form.amount,
        selectedMethod,
      }),
    });

    const sessionData = await sessionResponse.json();

    if (!sessionResponse.ok || !sessionData.success || !sessionData.checkout_url) {
      throw new Error("payment/create-session failed");
    }

    window.location.href = sessionData.checkout_url;
   } catch (error) {
    console.error("Stripe Checkout Fehler:", error);

    const message =
      error instanceof Error
        ? error.message
        : String(error);

    alert(message);

    setSubmitError(
      "Die Zahlung konnte nicht vorbereitet werden. Bitte versuchen Sie es erneut."
    );
  } finally {
    setIsSubmitting(false);
  }
};
    


const startPayment = async () => {
  setIsSubmitting(true);
  setSubmitError("");

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        caseReference: form.caseReference,
        debtorName: form.debtorName,
        creditorName: form.creditorName,
        amount: form.amount,
        mobile: form.mobile,
        email: form.email,
        differentPayer: form.differentPayer,
        payerName: form.payerName,
        payerMobile: form.payerMobile,
        payerEmail: form.payerEmail,
        selectedMethod,
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || "Zahlungsanfrage konnte nicht gespeichert werden.");
    }

    setInteractionId(data.interaction_id);
    setPaymentMode(false);
    setSuccessMode(true);
  } catch (error) {
    setSubmitError(
      "Die Zahlungsanfrage konnte nicht vorbereitet werden. Bitte versuchen Sie es erneut."
    );
  } finally {
    setIsSubmitting(false);
  }
};


if (successMode) {
  return (
    <main className="pay-page">
      <header className="pay-header">
        <img src={logo} alt="DI - Direkt Inkasso GmbH" className="pay-logo" />
        <div className="pay-trust">
          <span>Sicher</span>
          <span>DSGVO-konform</span>
          <span>SSL-verschlüsselt</span>
        </div>
      </header>

      <section className="pay-review">
        <div className="pay-pills">
          <span>Zahlungsbestätigung</span>
          <span>Vorgang übermittelt</span>
        </div>

        <h1>Vielen Dank.</h1>
        <p className="pay-text">
          Ihre Zahlung wurde vorbereitet. In der produktiven Version werden Sie
          nach erfolgreicher Zahlung eine Bestätigung per E-Mail erhalten.
        </p>

        <div className="pay-review-card">
          <ReviewRow label="Aktenzeichen" value={form.caseReference} />
          <ReviewRow label="Gläubiger" value={form.creditorName} />
          <ReviewRow label="Zahlbetrag" value={`${form.amount} €`} />
          <ReviewRow label="E-Mail-Adresse" value={form.email} />
          <ReviewRow label="Referenznummer" value={interactionId} />
        </div>

        <button
          type="button"
          className="pay-button"
          onClick={() => {
            setForm(initialForm);
            setConfirmed(false);
            setSelectedMethod("");
            setSuccessMode(false);
            setPaymentMode(false);
            setReviewMode(false);
          }}
        >
          Zur Startseite
        </button>
      </section>
    </main>
  );
}


if (paymentMode) {
  return (
    <main className="pay-page">
      <header className="pay-header">
        <img src={logo} alt="DI - Direkt Inkasso GmbH" className="pay-logo" />
        <div className="pay-trust">
          <span>Sicher</span>
          <span>DSGVO-konform</span>
          <span>SSL-verschlüsselt</span>
        </div>
      </header>

      <section className="pay-review">
        <div className="pay-pills">
          <span>Zahlungsart</span>
          <span>Sichere Zahlungsabwicklung</span>
        </div>

        <h1>Zahlungsart auswählen</h1>
        <p className="pay-text">
          Bitte wählen Sie aus, wie Sie Ihre Zahlung sicher abschließen möchten.
        </p>

        <div className="pay-review-card">
          <ReviewRow label="Aktenzeichen" value={form.caseReference} />
          <ReviewRow label="Gläubiger" value={form.creditorName} />
          <ReviewRow label="Schuldner" value={form.debtorName} />
          <ReviewRow label="Zahlbetrag" value={`${form.amount} €`} />
        </div>

        <div className="pay-method-select">
          <PaymentOption
            title="Kreditkarte"
            text="Visa, Mastercard oder American Express"
            value="card"
            selected={selectedMethod}
            onSelect={setSelectedMethod}
          />
          <PaymentOption
            title="Apple Pay"
            text="Schnell bezahlen mit Apple Pay"
            value="apple_pay"
            selected={selectedMethod}
            onSelect={setSelectedMethod}
          />
          <PaymentOption
            title="Google Pay"
            text="Schnell bezahlen mit Google Pay"
            value="google_pay"
            selected={selectedMethod}
            onSelect={setSelectedMethod}
          />
          <PaymentOption
            title="SEPA"
            text="Zahlung per SEPA-Lastschrift oder Bankverfahren"
            value="sepa"
            selected={selectedMethod}
            onSelect={setSelectedMethod}
          />

          <PaymentOption
  title="PayPal"
  text="Bezahlen mit Ihrem PayPal-Konto"
  value="paypal"
  selected={selectedMethod}
  onSelect={setSelectedMethod}
/>
        </div>

        <p className="pay-secure-note">
          Zahlungsdaten wie Karteninformationen werden nicht von der DI – Direkt
          Inkasso GmbH gespeichert. Die Zahlungsabwicklung erfolgt über einen
          zertifizierten Zahlungsdienstleister.
        </p>

        <div className="pay-review-actions">
          <button
            type="button"
            className="pay-button secondary"
            onClick={() => {
              setPaymentMode(false);
              setReviewMode(true);
            }}
          >
            Zurück zur Prüfung
          </button>

{submitError && <p className="pay-error">{submitError}</p>}

          <button
  type="button"
  className="pay-button"
  disabled={!selectedMethod || isSubmitting}
  onClick={startStripeCheckout}
>
  {isSubmitting ? "Zahlung wird vorbereitet..." : "Zahlung starten"}
</button>
        </div>
      </section>
    </main>
  );
}


  if (reviewMode) {
    return (
      <main className="pay-page">
        <header className="pay-header">
          <img src={logo} alt="DI - Direkt Inkasso GmbH" className="pay-logo" />
          <div className="pay-trust">
            <span>Sicher</span>
            <span>DSGVO-konform</span>
            <span>SSL-verschlüsselt</span>
          </div>
        </header>

        <section className="pay-review">
          <div className="pay-pills">
            <span>Prüfansicht</span>
            <span>Keine Registrierung erforderlich</span>
          </div>

          <h1>Bitte prüfen Sie Ihre Angaben</h1>
          <p className="pay-text">
            Ihre Angaben werden zunächst geprüft. Erst anschließend werden Sie
            sicher zur Auswahl der Zahlungsart weitergeleitet.
          </p>

          <div className="pay-review-card">
            <ReviewRow label="Aktenzeichen" value={form.caseReference} />
            <ReviewRow label="Name des Schuldners" value={form.debtorName} />
            <ReviewRow label="Gläubiger" value={form.creditorName} />
            <ReviewRow label="Zahlbetrag" value={`${form.amount} €`} />
            <ReviewRow label="Mobilnummer" value={form.mobile} />
            <ReviewRow label="E-Mail-Adresse" value={form.email} />

            {form.differentPayer && (
              <>
                <hr />
                <ReviewRow label="Zahlende Person" value={form.payerName} />
                <ReviewRow
                  label="Mobilnummer zahlende Person"
                  value={form.payerMobile || "Nicht angegeben"}
                />
                <ReviewRow
                  label="E-Mail zahlende Person"
                  value={form.payerEmail || "Nicht angegeben"}
                />
              </>
            )}
          </div>

<label className="pay-confirm">
  <input
    type="checkbox"
    checked={confirmed}
    onChange={(event) => setConfirmed(event.target.checked)}
  />
  <span>Ich bestätige die Richtigkeit meiner Angaben.</span>
</label>

          <div className="pay-review-actions">
            <button
              type="button"
              className="pay-button secondary"
              onClick={() => setReviewMode(false)}
            >
              Angaben bearbeiten
            </button>

            <button
  type="button"
  className="pay-button"
  disabled={!confirmed}
  onClick={() => {
    setReviewMode(false);
    setPaymentMode(true);
  }}
>
  Weiter zur Zahlungsart
</button>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="pay-page">
      <header className="pay-header">
        <img src={logo} alt="DI - Direkt Inkasso GmbH" className="pay-logo" />

        <div className="pay-trust">
          <span>Sicher</span>
          <span>DSGVO-konform</span>
          <span>SSL-verschlüsselt</span>
        </div>
      </header>

      <section className="pay-hero">
        <div className="pay-copy">
          <div className="pay-pills">
            <span>Serviceportal</span>
            <span>Sichere Zahlung</span>
            <span>Vertraulich</span>
          </div>

          <h1>Zahlung Ihrer Forderung</h1>

          <p className="pay-lead">
            Mit diesem Portal können Sie Ihre offene Forderung sicher bezahlen,
            Rückfragen stellen oder später eine Ratenzahlung vereinbaren.
          </p>

          <div className="pay-info-box">
            <strong>Für die Zahlung ist keine Registrierung erforderlich.</strong>
            <p>
              Sie benötigen lediglich die Angaben aus dem Schreiben oder der
              E-Mail der DI – Direkt Inkasso GmbH.
            </p>
          </div>

          <p className="pay-text">
            Ihre Angaben werden zunächst geprüft. Erst anschließend werden Sie
            sicher zur Auswahl der Zahlungsart weitergeleitet.
          </p>

          <div className="pay-steps">
            <div>
              <strong>1. Daten eingeben</strong>
              <p>
                Tragen Sie die Angaben aus dem Schreiben oder der E-Mail ein.
              </p>
            </div>
            <div>
              <strong>2. Angaben prüfen</strong>
              <p>Prüfen Sie die eingegebenen Zahlungsdaten in Ruhe.</p>
            </div>
            <div>
              <strong>3. Zahlung abschließen</strong>
              <p>Wählen Sie anschließend Ihre Zahlungsart.</p>
            </div>
          </div>
        </div>

        <form
          className="pay-form"
          onSubmit={(event) => {
            event.preventDefault();
            setReviewMode(true);
          }}
        >
          <div className="pay-form-section">
            <h2>Angaben aus Ihrem Schreiben oder Ihrer E-Mail</h2>
            <p>
              Bitte geben Sie die Angaben aus dem Schreiben oder der E-Mail der
              DI – Direkt Inkasso GmbH ein.
            </p>
          </div>

          <Field
            label="Aktenzeichen"
            required
            placeholder="z. B. 202512345678"
            value={form.caseReference}
            onChange={(value) => updateField("caseReference", value)}
          />
          <Field
            label="Name des Schuldners"
            required
            placeholder="z. B. Hans Mustermann"
            value={form.debtorName}
            onChange={(value) => updateField("debtorName", value)}
          />
          <Field
            label="Gläubiger"
            required
            placeholder="z. B. Muster GmbH"
            value={form.creditorName}
            onChange={(value) => updateField("creditorName", value)}
          />
          <Field
            label="Zahlbetrag"
            required
            placeholder="z. B. 150,00"
            suffix="€"
            value={form.amount}
            onChange={(value) => updateField("amount", value)}
          />

          <div className="pay-form-section">
            <h2>Kontaktdaten</h2>
            <p>
              Diese Angaben benötigen wir zur Zahlungsabwicklung sowie für
              Rückfragen und die Zahlungsbestätigung.
            </p>
          </div>

          <Field
            label="Mobilnummer"
            required
            placeholder="z. B. 0170 1234567"
            value={form.mobile}
            onChange={(value) => updateField("mobile", value)}
          />
          <Field
            label="E-Mail-Adresse"
            required
            type="email"
            placeholder="ihre@email.de"
            value={form.email}
            onChange={(value) => updateField("email", value)}
          />

          <label className="pay-checkbox">
            <input
              type="checkbox"
              checked={form.differentPayer}
              onChange={(event) =>
                updateField("differentPayer", event.target.checked)
              }
            />
            <span>Die Zahlung erfolgt durch eine andere Person.</span>
          </label>

          {form.differentPayer && (
            <>
              <div className="pay-form-section">
                <h2>Angaben zur zahlenden Person</h2>
                <p>
                  Bitte nur ausfüllen, wenn die Zahlung nicht durch den
                  Schuldner erfolgt.
                </p>
              </div>

              <Field
                label="Name der zahlenden Person"
                required
                placeholder="z. B. Erika Mustermann"
                value={form.payerName}
                onChange={(value) => updateField("payerName", value)}
              />
              <Field
                label="Mobilnummer"
                placeholder="optional"
                value={form.payerMobile}
                onChange={(value) => updateField("payerMobile", value)}
              />
              <Field
                label="E-Mail-Adresse"
                placeholder="optional"
                value={form.payerEmail}
                onChange={(value) => updateField("payerEmail", value)}
              />
            </>
          )}

          <button type="submit" className="pay-button">
            Zahlungsdaten prüfen
          </button>

          <div className="pay-payment-note">
            <strong>Sichere Zahlungsmöglichkeiten</strong>
            <p>
              Die verfügbaren Zahlungsarten werden Ihnen im nächsten Schritt
              angezeigt.
            </p>
            <div className="pay-methods">
              <span>Visa</span>
              <span>Mastercard</span>
              <span>American Express</span>
              <span>Apple Pay</span>
              <span>Google Pay</span>
              <span>SEPA</span>
            </div>
          </div>
        </form>
      </section>

      <section className="pay-benefits">
        <Benefit
          title="Sichere Onlinezahlung"
          text="Ihre Zahlung erfolgt sicher und zuverlässig."
        />
        <Benefit
          title="Sofortige Bestätigung"
          text="Sie erhalten eine Bestätigung nach Zahlung."
        />
        <Benefit
          title="Verschlüsselte Übertragung"
          text="Ihre Daten werden geschützt übertragen."
        />
        <Benefit
          title="Mehrere Zahlungsarten"
          text="Wählen Sie später Ihre passende Zahlungsart."
        />
      </section>

      <PayFooter />
    </main>
  );
}

function Field({
  label,
  required,
  placeholder,
  suffix,
  value,
  onChange,
  type = "text",
}) {
  return (
    <label className="pay-field">
      <span>
        {label} {required && <em>*</em>}
      </span>
      <div className="pay-input-wrap">
        <input
          type={type}
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        {suffix && <b>{suffix}</b>}
      </div>
    </label>
  );
}

function ReviewRow({ label, value }) {
  return (
    <div className="pay-review-row">
      <span>{label}</span>
      <strong>{value || "Nicht angegeben"}</strong>
    </div>
  );
}

function PaymentOption({ title, text, value, selected, onSelect }) {
  const isSelected = selected === value;

  return (
    <button
      type="button"
      className={`pay-method-option ${isSelected ? "selected" : ""}`}
      onClick={() => onSelect(value)}
    >
      <span className="pay-radio">{isSelected ? "●" : "○"}</span>
      <span>
        <strong>{title}</strong>
        <p>{text}</p>
      </span>
    </button>
  );
}


function Benefit({ title, text }) {
  return (
    <div className="pay-benefit">
      <div className="pay-benefit-icon">✓</div>
      <div>
        <strong>{title}</strong>
        <p>{text}</p>
      </div>
    </div>
  );
}